<template>
  <div>
    <ProductCard
      v-if="product"
      :key="`product-${product.id}`"
      data-test-id="product-item"
      :product="product"
      :image="image"
      :hover-image="hoverImage"
      :show-price-reduction="isInActiveSalePeriod"
      @click:product="$emit('click:product', product)"
    >
      <template #header-badge>
        <ProductCardBadges :product="product" />
      </template>
    </ProductCard>
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'

const props = defineProps<{
  index?: number
  width?: string
  fetching?: boolean
  product?: Product
}>()

defineEmits<{
  'click:product': [value: Product]
}>()

const image = computed(() => getFrontImage(props.product?.images))
const hoverImage = computed(() => getHoverImage(props.product?.images))

const { isActiveSalePeriod: isInActiveSalePeriod } = useSmartShopConfiguration()
</script>
